// extracted by mini-css-extract-plugin
export default {"pagination_container":"Paginator_pagination_container__gIyCe","pagination_item":"Paginator_pagination_item__SRd6-","pagination_item_active":"Paginator_pagination_item_active__wWnvv"};